import {
  GET_DASHBOARD_CONFIGS,
  GET_DASHBOARD_CONFIGS_EMPTY,
  GET_DASHBOARD_CONFIGS_ERROR,
  GET_DASHBOARD_CONFIGS_SUCCESS,
} from '../../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetDashboardConfigs = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_CONFIGS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_DASHBOARD_CONFIGS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_DASHBOARD_CONFIGS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_DASHBOARD_CONFIGS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetDashboardConfigs;
